export enum ActiveScreen {
  LOGIN = "Log in with Meridian",
  COMPANY = "Company",
  CONNECT = "Connect to Meridian",
  GOOGLE_MAIL = "Google mail",
  GOOGLE_CALENDAR = "Google calendar",
  EMAIL_MISMATCH = "Email mismatch",
  GET_OUTLOOK_ADDIN = "Get Outlook add-in",
  LOADING = "Loading",
  MEETING = "Meeting",
  SYNC_DISABLED = "Sync disabled",
  SYNC_EMAIL = "Sync email",
  SYNC_MEETING = "Sync meeting",
  THREAD = "Thread",
}

export enum ConnectionScreenState {
  Connect = "Connect your Meridian account",
  Reconnect = "Reconnect Meridian account",
  Waiting = "Waiting for connection…",
}

export enum SyncEmailActiveScreen {
  Syncing = "syncing",
  Issue = "issue",
  SyncDisabled = "sync_disabled",
}

export enum SyncEmailScreenAction {
  Sync = "sync",
  Subscribe = "subscribe",
}

export enum SubscribeScreenAction {
  SubscribeFull = "subscribe full thread",
  SubscribeFromCurrent = "subscribe from current email",
}
